import React, { useState } from 'react';
import {
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { Info } from '@phosphor-icons/react';
import { CustomIcon } from '../CustomIcon/CustomIcon.component';
import { useQuantitatives } from '../../contexts/QuantitativesContext';
import manualGerdau from '../../assets/Manual_Galpoes_em_Porticos_com_Perfis_Estruturais_Laminados.pdf';
import { TermsModal } from './components/TermsModal.component';
import * as S from './GeneralInfoModal.styles';

interface GeneralInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function GeneralInfoModal({ isOpen, onClose }: GeneralInfoModalProps) {
  const { setIsModalOpen } = useQuantitatives();
  const [checked, setChecked] = useState(false);
  const [openTermsModal, setOpenTermModal] = useState(false);

  return (
    <>
      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent p="24px">
          <CustomIcon
            icon={Info}
            color="#B3B3B3"
            boxSize={5}
            $bgColor="#F2F4F7"
            $borderColor="#F9FAFB"
            $isRounded
          />
          <ModalHeader p="0" mt="20px" mb="16px">
            Informações gerais
          </ModalHeader>
          <ModalBody p="0" display="flex" flexDirection="column" gap="16px">
            <Text color="#667085" fontSize="14px">
              Este programa não substitui um projeto elaborado por engenheiros ou arquitetos.
            </Text>
            <Text color="#667085" fontSize="14px">
              Essa ferramenta ainda está em fase de testes(beta). Inconsistências e pequenas
              variações de cálculo são normais e esperadas.
            </Text>
            <Text color="#667085" fontSize="14px">
              As condições para obtenção das informações de quantitativos seguem as premissas do{' '}
              <Text
                as={Link}
                href={manualGerdau}
                color="#564fff"
                style={{ textDecoration: 'underline' }}
                download="Manual_Gerdau"
              >
                Manual da Gerdau
              </Text>
              .
            </Text>
            <Text color="#667085" fontSize="14px">
              A seguir, você poderá realizar um cálculo preliminar da quantidade necessária de
              material para a construção do seu galpão, sem incluir a taxa de ligações entre os
              elementos.
            </Text>

            <Flex flexDirection="row">
              <S.CheckboxStyled
                margin="0 8px 0 0"
                alignSelf="flex-start"
                isChecked={checked}
                onChange={() => setChecked((prevState) => !prevState)}
              />
              <Flex flexDirection="row">
                <Text fontSize="14px" color="#667085">
                  Concordo com os{' '}
                  <Text
                    as="span"
                    fontSize="14px"
                    color="#564fff"
                    textDecoration="underline"
                    cursor={'pointer'}
                    onClick={() => setOpenTermModal((prevState) => !prevState)}
                  >
                    termos e condições
                  </Text>
                  <Text as="span" color="red">
                    {' '}
                    *
                  </Text>
                </Text>
              </Flex>
            </Flex>
          </ModalBody>

          <ModalFooter p="0" mt="32px">
            <Button
              w="100%"
              bgColor={checked ? '#022D58' : '#ECF0F1'}
              color="#fff"
              isDisabled={!checked}
              _disabled={{
                _hover: { bgColor: '##ECF0F1' },
              }}
              onClick={() => setIsModalOpen({ open: 'DimensionsModal', addNewQuantitativo: true })}
            >
              Continuar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {openTermsModal && (
        <TermsModal isOpen={openTermsModal} onClose={() => setOpenTermModal(false)} />
      )}
    </>
  );
}
